import { render, staticRenderFns } from "./FornecedorModal.vue?vue&type=template&id=04380728&scoped=true"
import script from "./FornecedorModal.vue?vue&type=script&lang=js"
export * from "./FornecedorModal.vue?vue&type=script&lang=js"
import style0 from "./FornecedorModal.vue?vue&type=style&index=0&id=04380728&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04380728",
  null
  
)

export default component.exports